import { useEffect, useState } from 'react';
import DotMenu, { Options } from '../../primitives/dotMenu/DotMenu';
import ActionDropdown from '../../primitives/dropdowns/ActionDropdown';
import userIcon from '../../assets/user-group.svg';
import ToastNotification from '../../Reusable/ToastNotification';
import { MenuConstants } from '../../../constants/MenuConstants';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppConstants } from '../../../constants/AppConstants';
import { useAppSelector } from '../../../app/hooks';
import PlusIcon from '@heroicons/react/outline/PlusIcon';
import AddInstructions from './AddInstructions';

interface AdminMenuProps {
  className?: string;
  iconSize?: string;
  AddQuestions: any;
  AddGroupQuestions: any;
  addScoringScheme: Function;
  flowType?: any;
  disabled?: any;
  showScoringScheme?: boolean;
  addInstructions: Function;
}

const AddQuestionMenu: React.FC<AdminMenuProps> = ({
  iconSize = '',
  AddQuestions,
  AddGroupQuestions,
  addScoringScheme,
  className = '',
  flowType,
  disabled = false,
  showScoringScheme = false,
  addInstructions
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const options: Array<any> = [];

  const [selectedOption, setSelectedOption] = useState<Options | null>();

  options.push({
    display: (
      <div>
        <div>{`${t('Question(S)')}`}</div>
        <div className="text-xs">{`${t('T_MENU_ADD_25_QUESTIONS')}`}</div>
      </div>
    ),
    key: MenuConstants.MENU_VIEW_SETTINGS,
    action: () => {
      AddQuestions();
    }
  });

  options.push({
    display: (
      <div>
        <div>{`${t('Group Question')}`}</div>
        <div className="text-xs">{`${t('T_MENU_BUNDLE_5_QUESTIONS')}`}</div>
      </div>
    ),
    key: MenuConstants.MENU_VIEW_SETTINGS,
    action: () => {
      AddGroupQuestions();
    }
  });

  if (showScoringScheme) {
    options.push({
      display: (
        <div>
          <div>{`${t('T_SCORING_SCHEME')}`}</div>
          <div className="text-xs">{`${t('T_SCORING_SCHEME_SUB')}`}</div>
        </div>
      ),
      key: MenuConstants.MENU_VIEW_SETTINGS,
      action: () => {
        addScoringScheme();
      }
    });
  }

  options.push({
    display: (
      <div>
        <div>{`${t('T_INSTRUCTIONS')}`}</div>
        <div className="text-xs">{`${t('T_INSTRUCTIONS_SUB')}`}</div>
      </div>
    ),
    key: MenuConstants.MENU_VIEW_SETTINGS,
    action: () => {
      addInstructions();
    }
  });

  const [toasterMessage, setToasterMessage] = useState('');
  const [isToastActive, setIsToastActive] = useState(false);
  const [toasterType, setToasterType] = useState<any>('success');

  return (
    <>
      <ToastNotification
        message={toasterMessage}
        isActive={isToastActive}
        setIsActive={setIsToastActive}
        status={toasterType}
      />
      <div>
        <ActionDropdown
          options={options}
          onSelectedOptionChange={(value: any) => {
            value.action();
            setSelectedOption(value);
          }}
          value={`+ ${t('T_ADD')}`}
          defaultLabel={`+ ${t('T_ADD')}`}
          maxHeight={400}
          className={`${flowType.isCreate || disabled ? 'disabled !w-[72px]' : '!w-[102px]'}`}
        />
      </div>

      {/* {selectedOption?.key === MenuConstants.MENU_VIEW_SETTINGS && AddQuestions()} */}
    </>
  );
};

export default AddQuestionMenu;
